import styles from './ArticleImage.module.scss';
import React from 'react';
import {AutoshipmentLogoMark} from "@zooplus/ui-components";

export type ArticleImageProps = {
  pictureUrl: string;
  hasAusIcon: boolean;
  small?: boolean;
  large?: boolean;
};

export const ArticleImage = (props: ArticleImageProps) => {


  return <div className={styles.wrapper}>
      <div className={`${styles.imageWrapper} ${props.small ? styles.smallPadding : styles.largePadding}`}>
          <img className={styles.img} src={props.pictureUrl} alt={'product image'}/>
      </div>
      {props.hasAusIcon && <div className={styles.ausIconCircle} data-testid="ausIcon">
          <AutoshipmentLogoMark className={styles.ausIcon}/>
      </div>}
  </div>
};
